import { breakpoints, Button, PageBlock, vars } from '@etg/wings';
import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import { DownloadSimple } from '@phosphor-icons/react';
import { crossSellBanners } from '../utils/crossSellBanners';

const bannerImageStyles = css`
  height: auto;
  width: 100%;
`;

const downloadButtonStyles = css`
  margin-top: 16px;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    width: 320px;
  }
`;

const wrapperStyles = css`
  @media (min-width: ${breakpoints._768}) {
    border: 1px solid ${etiColors.grayScale[6]};
    border-radius: ${vars.card.borderRadius};
    padding: 16px;
  }
`;

const CrossSellBanner = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { language } = useSiteContext();
  const getCrossSellBannerLink = p('Order.Partner.CrossSell.Link');
  const bannerForLanguage = crossSellBanners?.[language.code] ?? crossSellBanners.en;

  return (
    <PageBlock withPaddingY>
      <div className={wrapperStyles} data-testid="cross-sell-banner">
        <a
          data-testid="cross-sell-banner-image-link"
          href={getCrossSellBannerLink}
          rel="noreferrer"
          target="_blank"
        >
          <picture>
            <source
              data-testid="cross-sell-banner-image-desktop"
              media={`(min-width:${breakpoints._768})`}
              srcSet={bannerForLanguage.desktop}
            />
            <source
              data-testid="cross-sell-banner-image-tablet"
              media={`(min-width:${breakpoints._560})`}
              srcSet={bannerForLanguage.tablet}
            />
            <img
              alt={t('Receipt.Discount.Label')}
              className={bannerImageStyles}
              data-testid="cross-sell-banner-image-mobile"
              src={bannerForLanguage.mobile}
            />
          </picture>
        </a>
        <Button
          as="a"
          className={downloadButtonStyles}
          data-testid="cross-sell-banner-download-button"
          href="/files/pdf/adr-discount-barcode.pdf"
          rel="noreferrer"
          target="_blank"
        >
          <DownloadSimple aria-hidden size={24} />
          {t('Order.Partner.CrossSell.DownloadButton.Label')}
        </Button>
      </div>
    </PageBlock>
  );
};

export default CrossSellBanner;
